import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/layout/style";
import _Layout from "antd/es/layout";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyrightOutlined } from '@ant-design/icons';
import { Fragment } from 'react';
import GlobalFooter from './components/GlobalFooter';
var Footer = _Layout.Footer;

var FooterView = function FooterView(_ref) {
  var links = _ref.links,
      copyright = _ref.copyright,
      style = _ref.style,
      className = _ref.className,
      prefixCls = _ref.prefixCls;
  return _jsx(Footer, {
    className: className,
    style: _objectSpread({
      padding: 0
    }, style),
    children: _jsx(GlobalFooter, {
      links: links,
      prefixCls: prefixCls,
      copyright: copyright === false ? null : _jsxs(Fragment, {
        children: [_jsx(CopyrightOutlined, {}), " ", copyright]
      })
    })
  });
};

export default FooterView;